import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initPixel } from './lib/metaPixel';
render(<App data-id="element-267" />, document.getElementById('root'));
// Defer the (non-critical) Meta Pixel so it never blocks first paint / LCP.
const startPixel = () => initPixel();
if ('requestIdleCallback' in window) {
  ;
  (window as Window & {
    requestIdleCallback: (cb: () => void) => number;
  }).requestIdleCallback(startPixel);
} else {
  setTimeout(startPixel, 200);
}